<template>

    <modal-container>

        <div>

            <!-- Top navbar -->
            <modal-header
                :title="params.title"
                :right="'close-dark'"
                :noIcon="true">
            </modal-header>

            <template>

                <!-- Prompt content -->
                <prompt-div class="text-dark">

                    <!-- Layout body -->
                    <template v-slot:body>

                        <div class="d-flex align-items-center justify-content-center" style="height: 15rem; font-size: 0;">
                            <img src="images/illustration-schedule.svg">
                        </div>

                        <div class="pt-6">
                            <h3 class="font-lg font-weight-bolder">{{ params.shortText }}</h3>
                            <h4 class="font-md mt-5">{{ params.longText }}</h4>
                        </div>
                        <button class="btn btn-md btn-inverted text-primary px-7 mt-6" @click="$root.closeModal()">
                            Ok, I understand
                        </button>

                    </template>

                </prompt-div>

            </template>

        </div>

    </modal-container>

</template>

<script>
    export default {

        props: {
            params: {
                default: null,
            },
        }

    }
</script>